<template>
    <v-tooltip location="bottom">
        <template #activator="{ props }">
            <v-btn-icon
                class="align-end"
                v-bind="props"
                @click="openCloseDialog"
                data-cy="GeneralLedgerAlert_Click"
            >
                <v-badge color="red" :content="1" data-cy="GeneralLedgerAlert_Badge">
                    <v-icon class="pb-1" color="primary" size="x-large"> $oss-warning </v-icon>
                </v-badge>
            </v-btn-icon>
        </template>
        <span data-cy="GeneralLedgerAlert_Tooltip">{{ tooltipMessage }}</span>
    </v-tooltip>
    <oss-dialog v-model="isVisible" :hide-valid="true" :title="dialogTitle">
        <v-row class="pa-5 ma-0">
            <!-- <v-col
                v-for="accountingPeriodBalanceDiagnostic in accountingPeriodBalanceDiagnostics"
                :key="accountingPeriodBalanceDiagnostic.accountingPeriod.id"

            > -->
            <v-data-table
                :headers="headers"
                :items="check.accountingPeriodBalanceDiagnostics"
                :items-per-page="-1"
                class="table mt-2"
                fixed-header
                hide-default-footer
                dense
            >
                <template v-slot:item="props">
                    <tr>
                        <td>{{ formatDate(props.item.accountingPeriod.start) }}</td>
                        <td>{{ formatDate(props.item.accountingPeriod.end) }}</td>
                        <td>{{ newCommonFormatCurrency(props.item.check?.balanceDifference) }}</td>
                        <td>
                            {{
                                newCommonFormatCurrency(
                                    props.item.carryForwardCheck?.balanceDifference,
                                )
                            }}
                        </td>
                        <td>{{ props.item.documentNotBalancedChecks?.length || "-" }}</td>
                    </tr>
                </template>
            </v-data-table>
            <!-- </v-col> -->
        </v-row>
    </oss-dialog>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Component, toNative, Prop, Vue } from "vue-facing-decorator";

import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";

/**
 * Component for displaying the number of alerts/errors in generalLedger.
 */
@Component
export class GeneralLedgerAlert extends Vue {
    /**
     * Count of errors items. Mandatory prop.
     */
    @Prop({ required: true }) readonly check!: any;

    isVisible: boolean = false;

    headers = [
        { title: "Début", value: "start", sortable: false },
        { title: "Fin", value: "end", sortable: false },
        { title: "Ecart", value: "balanceDifference", sortable: false },
        { title: "Ecart AN", value: "CFbalanceDifference", sortable: false },
        { title: "Document déséquilibré", value: "unbalancedAT", sortable: false },
    ];

    openCloseDialog(): void {
        this.isVisible = !this.isVisible;
    }

    get tooltipMessage(): string {
        return this.$t("generalLedger.unbalancedBalance");
    }

    newCommonFormatCurrency(value) {
        return newCommonFormatCurrency(value, undefined);
    }

    formatDate(date) {
        if (!date) return "";
        moment.locale("fr");
        return moment(date).format("DD/MM/YYYY");
    }

    get dialogTitle() {
        return "Vérification des balances par exercice";
    }
}

export default toNative(GeneralLedgerAlert);
</script>
